import { useState, useEffect } from 'react';
import IsMobile from './isMobile';

export default function useCheckScroll(
  containerRef: React.RefObject<HTMLElement>,
  threshold: number = 20,
  trigger: boolean = false
) {
  const isMobile = IsMobile();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setExpanded(false);
      return;
    }
    const container = containerRef.current;
    if (!container) return;

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setExpanded(container.scrollTop > threshold);
          ticking = false;
        });
        ticking = true;
      }
    };

    container.addEventListener('scroll', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [containerRef, threshold, trigger, isMobile]);

  return expanded;
}
